module.exports = __webpack_public_path__ + "static/Business.c832684b.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/services/Business.png
// module id = 360
// module chunks = 35783957827783